export const linkStyle = {
  color: 'primary.400',
  '&:hover': {
    color: 'primary.600',
  },
}

export const listStyle = {
  fontSize: 'md',
  listStylePosition: 'inside',
  listStyleType: 'none',
  textAlign: 'left',
  marginLeft: '-1px',

  '& li': {
    display: 'flex',
  },
  '& li::before': {
    content: '"•"',
    display: 'inline',
    pr: 2,
  },
}

export const strongStyle = {
  fontWeight: 'medium',
}

export const strongStylePrimary = {
  ...strongStyle,
  color: 'primary.400',
}

export const gridStyle = {
  py: {
    base: 7,
    sm: 12,
  },
  gridTemplateColumns: {
    base: '1fr',
    md: 'repeat(2, 1fr)',
  },
  gridTemplateRows: 'repeat(auto-fit, minmax(max-content, 1fr))',
  gridGap: {
    base: 6,
    md: 7,
  },
  alignItems: 'stretch',
  color: 'gray.900',
  fontSize: 'md',
}

export const gridSpanStyle = {
  gridColumn: { md: '1 / 3' },
}

export const textStyle = {
  fontSize: 'md',
}
